import {
    CURRENCIES_FETCH,
    CURRENCIES_FETCH_ALL,
    CURRENCIES_CONVERSION,
    CURRENCIES_IS_FETCING,
    CURRENCIES_API,
    CURRENCY_EDIT,
    CURRENCY_FILTER,
} from 'constants/currencies'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

//Save Currencies
export const currencySave = (data) => (dispatch, state) => {
    let action;
    if (data.currencyId)
        action = put;
    else
        action = post;
    dispatch(currenciesIsFetching(true))
    return action(CURRENCIES_API, data)
        .then((e) => { dispatch(currenciesIsFetching(false)); return e; })
        .catch((e) => { dispatch(currenciesIsFetching(false)); throw new Error(e) })
}

//Feth currency by id
export const currencyFetch = (id) => (dispatch, state) => {
        dispatch(currenciesIsFetching(true));
        return get(CURRENCIES_API + '/' + id)
            .finally(e => dispatch(currenciesIsFetching(false)))
}

//Fetch all currencies paging
export const currenciesFetch = () => (dispatch, state) => {
    dispatch(currenciesIsFetching(true));
    const filter = state().currencies.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    return get(CURRENCIES_API, {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        })
        .then((e) => {
            dispatch(currenciesFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                currencyFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(currenciesIsFetching(false)))

}

//Fetch all currencies list
export const currenciesFetchAll = () => (dispatch, state) => {
    dispatch(currenciesIsFetching(true));
    return get(CURRENCIES_API, {
            size: 100000
        })
        .then((e) => {
            dispatch(currenciesFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                currencyFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(currenciesIsFetching(false)))

}


//Convert 2 currencies by id
export const currencyConversion = (native_currency_id,foreign_currency_id) => (dispatch, state) => {
        dispatch(currenciesIsFetching(true));
        return get(CURRENCIES_API + '/' + native_currency_id + '/conversion/' + foreign_currency_id)
            .finally(e => dispatch(currenciesIsFetching(false)))
}


//Remove one currency
export const currencyRemove = (id) => (dispatch, state) => {
    dispatch(currenciesIsFetching(true))
    return remove(CURRENCIES_API + '/' + id)
        .finally(e => dispatch(currenciesIsFetching(false)))
}
export const currenciesFetched = (payload) => ({ type: CURRENCIES_FETCH, payload: payload })
export const currenciesFetchedAll = (payload) => ({ type: CURRENCIES_FETCH_ALL, payload: payload })
export const currenciesConverted = (payload) => ({ type: CURRENCIES_CONVERSION, payload: payload })
export const currenciesIsFetching = (payload) => ({ type: CURRENCIES_IS_FETCING, payload: payload })
export const currencyEdit = (id, data) => ({ type: CURRENCY_EDIT, payload: data })
export const currencyFilter = (data) => ({ type: CURRENCY_FILTER, payload: data })


// WEBPACK FOOTER //
// ./src/actions/currencies.js